export default __webpack_public_path__ + "static/media/who-we-are.dbd45040.png";